import React from "react";
import {RoundButton} from "./RoundButton";
import {GroupInit} from "../pages/GroupInit";
import {GroupShowNoEdit} from "../pages/GroupShowNoEdit";

export class RoundManager extends React.Component
{
    constructor(props)
    {
        super(props);

        this.eventHandler = this.eventHandler.bind(this);

        this.state =
            {
                student_mode: window.app.logboek.getSessionField('student_mode'),
                multiple_rounds: window.app.logboek.getSessionField('multiple_rounds'),
                multiple_instructions: window.app.logboek.getSessionField('multiple_instructions'),
                multiple_group_divisions: window.app.logboek.getSessionField('multiple_group_divisions'),
                current_round: window.app.logboek.getSessionField('current_round'),
                round_status: window.app.logboek.getSessionField('round_status'),
            }

        console.log("constructor RoundManager");
        console.log(this.state);
    }


    eventHandler(p_event)
    {
        console.log(p_event);

        let new_round_status = this.state.round_status;
        let new_current_round = this.state.current_round;
        let action = "";

        switch (p_event)
        {
            case "go_back":
                window.app.prevPage();
                return;
                break;
            case "goto_init":
                new_round_status = "init";
                new_current_round++;
                action = "init_round";
                break;

            case "goto_init_from_review":
                new_round_status = "init";
                break;

            case "goto_divide":
                new_round_status = "divide";
                break;

            case "goto_active":
            case "goto_active_skip_divide":
                new_round_status = "active"

                break;

            case "goto_review":
                new_round_status = "review";
                break;

            case "goto_closed":
                new_round_status = "closed";
                break;
        }

        this.storeRoundStatus(new_current_round, new_round_status, action).then(r =>
            {

                window.app.setSessionField("current_round", new_current_round);
                window.app.setSessionField("round_status", new_round_status);

                switch (p_event)
                {
                    case "goto_init_from_review":
                        window.app.prevPage(4);
                        break;

                    case "goto_active_skip_divide":
                        window.app.nextPage(2);
                        break;

                    default:
                        window.app.nextPage();
                }
            }
        );
    }

    async storeRoundStatus(p_current_round, p_round_status, p_action)
    {
        const formData = new FormData();
        formData.append("app_user_id", window.app.user.id);
        formData.append("wachtwoord", window.app.user.password);


        formData.append("current_round", p_current_round);
        formData.append("round_status", p_round_status);
        formData.append("action", p_action);


        const requestOptions = {
            method: 'POST',
            body: formData
        };


        await fetch("/store_spelend_round", requestOptions)
            .then(response => response.json())
            .then(login_json =>
            {
                if (login_json.status == "err")
                {
                    console.log("error");
                } else
                {
                    console.log("ok");
                }
            });

    }

    render()
    {
        return (
            <div className={"tool__content__page__wrapper"}>
                <h1>{this.props.page.title}</h1>
                <h2>Ronde {(this.props.mode == 'preinit') ? parseInt(this.state.current_round) + 1 : this.state.current_round}</h2>

                <div className={this.props.page.font_size == "pupil" ? "tool__content__page__content_pupil" :  "tool__content__page__content_teacher"} dangerouslySetInnerHTML={{__html: this.props.page.content}}></div>


                {this.props.mode == 'preinit' && (

                    <>

                        {this.state.multiple_rounds == 'N' &&
                            (
                                <>
                                    {this.state.student_mode == 'teacher' &&
                                        (
                                            <p>Je gaat met 1 ronde werken, waarbij je zelf alle kinderen indeelt.</p>
                                        )}

                                    {this.state.student_mode == 'both' &&
                                        (
                                            <p>Je gaat met 1 ronde werken, waarbij je samen de kinderen indeelt.</p>
                                        )}

                                    {this.state.student_mode == 'student' &&
                                        (
                                            <p>Je gaat met 1 ronde werken, waarbij de kinderen zichzelf indelen.</p>
                                        )}

                                </>
                            )}

                        {this.state.multiple_rounds == 'Y' &&
                            (
                                <p>
                                    * Je gaat met meerdere rondes werken.<br/>


                                    {this.state.multiple_instructions == 'Y' && (
                                        <>* Elke ronde kan/ga je de opdracht per hoek aanpassen.</>
                                    )}

                                    {this.state.multiple_instructions == 'N' && (
                                        <>* De opdracht is per ronde per hoek hetzelfde.</>
                                    )}
                                    <br/>

                                    {this.state.multiple_group_divisions == 'Y' && (
                                        <>* Elke ronde kan/ga je de kinderen per hoek aanpassen.</>
                                    )}

                                    {this.state.multiple_group_divisions == 'N' && (
                                        <>* De kinderen blijven per ronde in dezelfde samenstelling.</>
                                    )}
                                    <br/>

                                    {this.state.student_mode == 'teacher' &&
                                        (
                                            <>* Waarbij je zelf alle kinderen indeelt.</>
                                        )}

                                    {this.state.student_mode == 'both' &&
                                        (
                                            <>* Waarbij je samen de kinderen indeelt.</>
                                        )}

                                    {this.state.student_mode == 'student' &&
                                        (
                                            <>* Waarbij de kinderen zichzelf indelen.</>
                                        )}

                                </p>
                            )}


                        <p><strong>Je kan nu nog bovenstaande werkmethode aanpassen, als je na dit scherm verder gaat kan dat niet meer.</strong></p>
                        <RoundButton callback={this.eventHandler} label={"Werkmethode aanpassen"} event_name={"go_back"}/>


                        <RoundButton callback={this.eventHandler} label={"Klaar om te gaan spelen"} event_name={"goto_init"}/>


                    </>
                )}


                {this.props.mode == 'init' && (

                    <>


                        <GroupInit mode={this.props.mode}/>


                        {this.state.student_mode == 'teacher' &&
                            (
                                <RoundButton callback={this.eventHandler} label={"Klaar met de indeling, start met de activiteiten"} event_name={"goto_active_skip_divide"}/>
                            )}

                        {this.state.student_mode != 'teacher' &&
                            (
                                <RoundButton callback={this.eventHandler} label={"Klaar met de instructies, laat de kinderen nog indelen"} event_name={"goto_divide"}/>
                            )}
                    </>
                )}


                {this.props.mode == 'divide' && (

                    <>
                        <p>Indelen van de kinderen {this.state.current_round} en status {this.state.round_status}</p>

                        <GroupInit mode={this.props.mode}/>
                        <RoundButton callback={this.eventHandler} label={"Klaar met de indeling, start met de activiteiten"} event_name={"goto_active"}/>


                    </>
                )}

                {this.props.mode == 'active' && (
                    <>
                        <GroupShowNoEdit show_log />

                        <img src={"/get_qrcode/?access_id1=" + window.app.logboek.access_id1 + "&access_id2=" + window.app.logboek.access_id2} className="qrcode_image"/><br/>
                        <a href={"/log/" + window.app.logboek.access_id1 + "/" + window.app.logboek.access_id2} target={"_blank"} className={"button"}>Naar de logger</a>

                        <RoundButton callback={this.eventHandler} label={"Klaar met loggen, bespreek de voortgang"} event_name={"goto_review"}/>

                    </>
                )}

                {this.props.mode == 'review' && (
                    <>
                        <GroupShowNoEdit show_log />

                        <RoundButton callback={this.eventHandler} label={"Nieuwe ronde beginnen"} event_name={"goto_init_from_review"}/>
                        <RoundButton callback={this.eventHandler} label={"Stoppen"} event_name={"goto_closed"}/>


                    </>
                )}

            </div>

        );
    }

}
